import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  signOut as signOutGoogle,
} from "firebase/auth";

export function signIn() {
  const provider = new GoogleAuthProvider();
  const auth = getAuth();
  return signInWithPopup(auth, provider);
}

export function signOut() {
  const auth = getAuth();
  signOutGoogle(auth);
}
